module.exports = __webpack_public_path__ + "3d78866a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3d78866a.png
// module id = 628
// module chunks = 0